import { settingsServiceFactory } from './settings';
//import { AngularStickyThingsModule } from '@w11k/angular-sticky-things';
import { _window } from './shared/services/window.token';
import { StickyHeaderDirective } from './shared/layout/header/sticky-header.directive';
const DIRECTIVES = [StickyHeaderDirective, StickyHeaderDirective];
const ɵ0 = settingsServiceFactory, ɵ1 = _window;
export class AppModule {
}
export { ɵ0, ɵ1 };
